import { services } from "../../../constants/services";
import { getByQuery } from "../../../utils/api";
import { IParamsBuilding, ResponseQ } from "../../../common/dtos/paginate.dto";

export class GetFilesWithPaginationService{ async run(params: IParamsBuilding) {
  const response = await getByQuery<ResponseQ<any>>(`${services.rotationScreen}/getFiles`, params);
  return response;
};}